import React from 'react';

import Chip from 'components/Chip/Chip';

import { colors } from 'theme/colors';

import { MembershipMode } from 'utils/api/modules/memberGroups';

import { GroupTypeChipProps } from './types';

const TYPE_COLORS: Record<MembershipMode, { background: string }> = {
  [MembershipMode.Dynamic]: { background: colors.tint.primary.medium },
  [MembershipMode.Manual]: { background: colors.tint.warning.medium },
};

const TYPE_LABELS: Record<MembershipMode, string> = {
  [MembershipMode.Dynamic]: 'Dynamic',
  [MembershipMode.Manual]: 'Manual',
};

const GroupTypeChip: React.FunctionComponent<GroupTypeChipProps> = ({ type }) => (
  <Chip
    label={TYPE_LABELS[type]}
    size="small"
    variant="outlined"
    colors={{ ...TYPE_COLORS[type], foreground: colors.text.primary, border: 'transparent' }}
    capitalizeLabel={false}
  />
);

export default GroupTypeChip;
